var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page noselect" },
    [
      _c("v-container", { attrs: { "grid-list-md": "" } }, [
        _c(
          "div",
          { staticClass: "text-center mt-7" },
          [
            _c("h2", [_vm._v("Hinweise zu Allergenen")]),
            _c("div", { staticClass: "spacer-25" }),
            _c("div", { staticClass: "text-left" }, [
              _c("p", [_vm._v(" Liebe Gäste, ")]),
              _c("p", [
                _vm._v(
                  " Wir bereiten alle Speisen für dich frisch zu und verzichten, womöglich, auf Konservierungsstoffe und Geschmacksverstärker. Wir haben versucht alle möglichen enthaltenen Allergene und Zusatzstoffe zu kennzeichnen. Sollten noch Fragen offen sein, versuchen wir gerne weiterzuhelfen. "
                ),
              ]),
            ]),
            _c("div", { staticClass: "spacer-15" }),
            _c("AllergenLegende", { attrs: { compact: false } }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }